import {NgxFilterBaseComponent} from "../ngx-filter-base-component";

export abstract class NgxTrueFalseFilter extends NgxFilterBaseComponent {

}
